module.exports = __webpack_public_path__ + "static/media/thanks-for-your-purchase.f672e4c2.svg";